import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

export const MANEJO_KEYS = [
  'femea_0_12', 'femea_13_24', 'femea_25_36', 'femea_acima_36',
  'macho_0_12', 'macho_13_24', 'macho_25_36', 'macho_acima_36',
];

export const ERAS = [
  { key: '0_12', label: '0 a 12 meses' },
  { key: '13_24', label: '13 a 24 meses' },
  { key: '25_36', label: '25 a 36 meses' },
  { key: 'acima_36', label: 'Acima de 36 meses' },
];

export const manejoZerado = () => MANEJO_KEYS.reduce((acc, k) => ({ ...acc, [k]: 0 }), {});

export const totalManejo = (m) => MANEJO_KEYS.reduce((s, k) => s + (parseInt(m?.[k]) || 0), 0);

/**
 * Grid 2 sexos × 4 eras para edição de quantidades de manejo.
 * Modo `disabled` → apenas exibe (read-only).
 * Modo `max` (objeto) → limita o valor por célula (usado em Transferir).
 */
export default function ManejoGrid({ value, onChange, disabled = false, max = null, label = 'Manejo' }) {
  const handleCell = (sexo, era, raw) => {
    const k = `${sexo}_${era}`;
    let v = parseInt(raw) || 0;
    if (v < 0) v = 0;
    if (max && max[k] !== undefined && v > max[k]) v = max[k];
    onChange && onChange({ ...value, [k]: v });
  };

  const total = totalManejo(value);
  const totalMacho = ERAS.reduce((s, e) => s + (parseInt(value?.[`macho_${e.key}`]) || 0), 0);
  const totalFemea = ERAS.reduce((s, e) => s + (parseInt(value?.[`femea_${e.key}`]) || 0), 0);

  return (
    <div className="border rounded-lg overflow-hidden bg-card" data-testid="manejo-grid">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-muted/50">
              <th className="text-left p-2 text-xs uppercase tracking-wider text-muted-foreground">{label}</th>
              {ERAS.map(e => (
                <th key={e.key} className="text-center p-2 text-[11px] uppercase tracking-wider text-muted-foreground">{e.label}</th>
              ))}
              <th className="text-center p-2 text-[11px] uppercase tracking-wider text-muted-foreground bg-emerald-100/50">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t">
              <td className="p-2 font-medium text-pink-700">♀ Fêmea</td>
              {ERAS.map(e => {
                const k = `femea_${e.key}`;
                const cellMax = max ? max[k] : null;
                return (
                  <td key={e.key} className="p-1.5">
                    <Input
                      type="number"
                      min="0"
                      max={cellMax !== null && cellMax !== undefined ? cellMax : undefined}
                      value={value?.[k] || 0}
                      onChange={(ev) => handleCell('femea', e.key, ev.target.value)}
                      disabled={disabled || (cellMax === 0)}
                      className="h-8 text-center"
                      data-testid={`manejo-${k}`}
                    />
                    {cellMax !== null && cellMax !== undefined && (
                      <p className="text-[9px] text-center text-muted-foreground mt-0.5">de {cellMax}</p>
                    )}
                  </td>
                );
              })}
              <td className="p-2 text-center font-bold text-pink-700 bg-pink-50">{totalFemea}</td>
            </tr>
            <tr className="border-t">
              <td className="p-2 font-medium text-sky-700">♂ Macho</td>
              {ERAS.map(e => {
                const k = `macho_${e.key}`;
                const cellMax = max ? max[k] : null;
                return (
                  <td key={e.key} className="p-1.5">
                    <Input
                      type="number"
                      min="0"
                      max={cellMax !== null && cellMax !== undefined ? cellMax : undefined}
                      value={value?.[k] || 0}
                      onChange={(ev) => handleCell('macho', e.key, ev.target.value)}
                      disabled={disabled || (cellMax === 0)}
                      className="h-8 text-center"
                      data-testid={`manejo-${k}`}
                    />
                    {cellMax !== null && cellMax !== undefined && (
                      <p className="text-[9px] text-center text-muted-foreground mt-0.5">de {cellMax}</p>
                    )}
                  </td>
                );
              })}
              <td className="p-2 text-center font-bold text-sky-700 bg-sky-50">{totalMacho}</td>
            </tr>
            <tr className="border-t-2 bg-emerald-50">
              <td className="p-2 font-bold text-emerald-800">TOTAL</td>
              {ERAS.map(e => {
                const totEra = (parseInt(value?.[`femea_${e.key}`]) || 0) + (parseInt(value?.[`macho_${e.key}`]) || 0);
                return <td key={e.key} className="p-2 text-center font-semibold text-emerald-800">{totEra}</td>;
              })}
              <td className="p-2 text-center font-bold text-lg text-emerald-700">{total}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
